module.exports = __webpack_public_path__ + "img/gmpLogo.266f6656.png";